import axios from "../config/axios";
import Constants from "../data/Constants";

export const getUserOrders = async (id) => {
  return await axios
    .get(Constants.ENDPOINTS.ORDER.USER_LIST + id)
    .then((res) => {
      return res.data.result;
    });
};

export const getAllOrders = async () => {
  return await axios.get(Constants.ENDPOINTS.ORDER.LIST).then((res) => {
    return res.data.result;
  });
};
